<template>
  <div class="mb-16 relative -mr-4 sm:-mr-8 md:-mr-8 lg:-mr-[8.5rem] xl:-mr-24">
    <div 
    ref="scrollContainer"
    @scroll="handleScroll"
    class="w-full overflow-x-scroll hide-scrollbar text-xs comparison-table-scroll"
    >  
      <div class="comparison-table">
        
        <!-- Column for "Feature Name" -->
        <div class="table-column">
          <div class="cell header-cell"></div>
          <div class="cell pointer" @click="priceModal = true">Pricing <Icon name="iconoir:help-circle" style="height: 14px; width: 14px; position: relative; top: -1px; left: 5px;" /></div>
          <div class="cell">Based in</div>
          <div class="cell">Market</div>
          <div class="cell font-bold">Features</div>
          <div class="cell">Anonymous reporting</div>
          <div class="cell">Confidential reporting</div>
          <div class="cell">Voice reporting</div>
          <div class="cell">Pulse surveys</div>
          <div class="cell">Advanced case management</div>
          <div class="cell">Analytics</div>
          <div class="cell">iPhone/Android app</div>
          <div class="cell">In-app legal expertise</div>
          <div class="cell">Personalised onboardings</div>
          <div class="cell">End-to-end encryption</div>
          <!-- <div class="cell">Additional security</div> -->
          <div class="cell">Languages</div>
          <div class="cell">Auto-translation</div>
          <!-- <div class="cell">Used by</div> -->
          <div class="cell font-bold">Compliance</div>
          <div class="cell">ISO 27001</div>
          <div class="cell">SOC 2</div>
          <div class="cell">SOX (USA)</div>
          <div class="cell">EU Directive (EU)</div>
          <div class="cell">GDPR (EU)</div>
          <div class="cell">Corporations Act (AU)</div>
          <div class="cell">Sex Discrimination Act (AU)</div>
        </div>
        

        <!-- Column for "Elker" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://elker.com" target="_blank">Elker <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">Australia</div>
          <div class="cell">ANZ & International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">All</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">University of Melbourne<br>Solotel<br>AirRoad</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
        </div>

        <!-- Column for "FaceUp" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.faceup.com/en" target="_blank" rel="nofollow noopener">FaceUp <Icon name="gridicons:external" /></a></div>
          <div class="cell">From $49 USD/month</div>
          <div class="cell">Czechia</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell">via partners</div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">113</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">Skoda<br>Vercel<br>Kiwi</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Whistleblower Software" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://whistleblowersoftware.com/en" target="_blank" rel="nofollow noopener">Whistleblower Software <Icon name="gridicons:external" /></a></div>
          <div class="cell">From €70/month</div>
          <div class="cell">Denmark</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell">via partners</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">80</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">McDonalds<br>Tomorrow<br>NOVA University Lisbon</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "AllVoices" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.allvoices.co" target="_blank" rel="nofollow noopener">AllVoices <Icon name="gridicons:external" /></a></div>
          <div class="cell">From $110 USD/month</div>
          <div class="cell">USA</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell">SOC2</div> -->
          <div class="cell">English</div>
          <div class="cell">To English</div>
          <!-- <div class="cell">Zillow<br>Electronic Arts<br>Duolingo</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Falcony" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.falcony.io" target="_blank" rel="nofollow noopener">Falcony <Icon name="gridicons:external" /></a></div>
          <div class="cell">From €120/month</div>
          <div class="cell">Finland</div>
          <div class="cell">EU</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell"></div> -->
          <div class="cell">29+</div>
          <div class="cell"></div>
          <!-- <div class="cell">Puma<br>Finnair<br>Posti</div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Whistlelink" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.whistlelink.com" target="_blank" rel="nofollow noopener">Whistlelink <Icon name="gridicons:external" /></a></div>
          <div class="cell">From €49/month</div>
          <div class="cell">Sweden</div>
          <div class="cell">International (EU focus)</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell">via partners</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">1+</div>
          <div class="cell"></div>
          <!-- <div class="cell">Burger King<br>Italia<br>Morris Law</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Suggestion Ox" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://suggestionox.com" target="_blank" rel="nofollow noopener">Suggestion Ox <Icon name="gridicons:external" /></a></div>
          <div class="cell">From $83 USD/month</div>
          <div class="cell">USA</div>
          <div class="cell">USA</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell"></div> -->
          <div class="cell">English</div>
          <div class="cell"></div>
          <!-- <div class="cell">Glassdoor<br>Samsung<br>Nissan</div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "CaseIQ" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.caseiq.com/" target="_blank" rel="nofollow noopener">CaseIQ <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">Canada</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell">SOC2</div> -->
          <div class="cell">150+</div>
          <div class="cell"></div>
          <!-- <div class="cell">NASA<br>UPS<br>IBM</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Canary" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.canary-whistleblowing.com/en/" target="_blank" rel="nofollow noopener">Canary <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">Indonesia, Malaysia, Thailand</div>
          <div class="cell">Southeast Asia</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell"></div> -->
          <div class="cell">3+</div>
          <div class="cell"></div>
          <!-- <div class="cell">WWF<br>Yamaha<br>GMF AeroAsia</div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Vault Platform" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://vaultplatform.com" target="_blank" rel="nofollow noopener">Vault Platform <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">United Kingdom</div>
          <div class="cell">International (EU/US focus)</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell">ISO27001, SOC2</div> -->
          <div class="cell">75</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">AirBnb<br>UpWork<br>Lemonade</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Legality Whistleblowing" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.whistleblowing.software/en/app-legality-whistleblowing-software/" target="_blank" rel="nofollow noopener">Legality Whistleblowing <Icon name="gridicons:external" /></a></div>
          <div class="cell">From €29/month</div>
          <div class="cell">Italy</div>
          <div class="cell">EU</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">10+</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">Toyota<br>Reale Seguros<br>Istituto Italiano di Tecnologia</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Whistle Willow" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://scrummaister.com/ww" target="_blank" rel="nofollow noopener">Whistle Willow <Icon name="gridicons:external" /></a></div>
          <div class="cell">50c/user/month</div>
          <div class="cell">Sweden</div>
          <div class="cell">EU</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell"></div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell"></div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Navex One" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.navex.com/en-us/products/" target="_blank" rel="nofollow noopener">Navex One <Icon name="gridicons:external" /></a></div>
          <div class="cell">From €133/month</div>
          <div class="cell">USA</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">10+</div>
          <div class="cell"></div>
          <!-- <div class="cell">Dell<br>Verizon<br>Palo Alto Networks</div> -->
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "EQS Integrity Line" -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://www.eqs.com/compliance-solutions/integrity-line/" target="_blank" rel="nofollow noopener">EQS Integrity Line <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">Germany</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">ISO27001</div> -->
          <div class="cell">80+</div>
          <div class="cell" v-html="tick"></div>
          <!-- <div class="cell">Continental<br>Peek&Cloppenburg<br>Hello Fresh</div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>

        <!-- Column for "Ethico (formerly ComplianceLine) " -->
        <div class="table-column">
          <div class="cell header-cell"><a href="https://ethico.com" target="_blank" rel="nofollow noopener">Ethico (formerly ComplianceLine)  <Icon name="gridicons:external" /></a></div>
          <div class="cell">Price on request</div>
          <div class="cell">USA</div>
          <div class="cell">International</div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell"></div>
          <!-- <div class="cell">SOC2</div> -->
          <div class="cell">All</div>
          <div class="cell"></div>
          <!-- <div class="cell">John Hopkins University<br>Pruitt Health<br>Genesis HealthCare</div> -->
          <div class="cell"></div>
          <div class="cell"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell" v-html="tick"></div>
          <div class="cell"></div>
          <div class="cell"></div>
        </div>
    
      </div>  
    </div>
    <p class="mt-8 text-xs text-gray-500">Note: the information in this table has been sourced from publicly available data. If there are any inaccuracies, please <NuxtLink :to="$localePath('/contact')">contact us</NuxtLink>.</p>

    <TransitionRoot as="template" :show="priceModal === true">
      <Dialog as="div" class="relative z-10" @close="priceModal = null">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="flex min-h-full justify-center p-4 text-center items-center">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <DialogPanel class="relative transform overflow-hidden rounded-lg bg-[#f9f8f6] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div class="bg-[#f9f8f6] p-6 sm:p-6 lg:p-8 prose">
                  <div>
                    <div class="mt-3 prose">
                      <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 mt-0">
                        Why is some software "price on request"?
                      </DialogTitle>
                      <div class="mt-2">
                        <p class="text-sm">
                          The <NuxtLink :to="$localePath('/pricing')">pricing</NuxtLink> of whistleblowing software often varies based on factors like the size of your organisation, the specific features you need, and your unique compliance requirements. While a standard pricing model might suffice for some companies, others need custom solutions that align with their existing systems and address complex case management needs. This is why a tailored quote, based on your organisation's particular requirements, is often more beneficial. 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

  </div>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
const scrollContainer = ref(null)
const priceModal = ref(null)
const tick = `<svg class="w-4 h-4 text-[#096b72]" aria-hidden="true" fill="none" viewBox="0 0 16 12"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"></path></svg>`
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
.comparison-table {
  display: flex;
  
  table tr, table td, table th {
    border: 1px solid;
  }

  .table-column {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .cell {
    color: $grey-4;
    padding-bottom: 2px;
    border-bottom: 1px solid #ddd;
    min-width: 105px;
    height: 32px;
    align-items: flex-end;
    display: flex;
    font-size: 11px;
    line-height: 1.1;
    @media (min-width: 500px) {
      min-width: 180px;
      padding-bottom: 5px;
      height: 30px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .cell:first-child {
    height: 70px;
    position: sticky;
    top: 0;
    border-bottom: 0;
  }

  .header-cell {
    font-weight: bold;
    color: $black;
    font-size: 14px;
    line-height: 1.2;
    @media (max-width: 499px) {
      svg {
        display: none;
      }
    }
    @media (min-width: 500px) {
      font-size: 18px;
    }
  }

  .header-cell svg {
    position: relative;
    top: -3px;
    left: 0px;
    width: 15px;
    height: 15px;
  }

  .table-column:not(:first-child) {
    margin-left: 10px;
    @media (min-width: 500px) {
      margin-left: 20px;
    }
  }

  .table-column:last-child {
    padding-right: 20px;
  }

  .table-column:first-child {
    // background-color: #fff;
    background: #f9f8f6;
    color: $grey-4;
    width: 111px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;

    @media (min-width: 500px) {
      width: 190px;
    }
    .font-bold {
      color: $black;
    }
    .header-cell:first-child {
      border-bottom: 0;
    }
  }

  .table-column:nth-child(2) {
    margin-left: 120px;
    @media (min-width: 500px) {
      margin-left: 210px;
    }
  }

  .table-column .cell:nth-child(5),
  .table-column .cell:nth-child(18) {
    border-bottom: 0;
    height: 40px;
    @media (min-width: 500px) {
      height: 60px;
    }
  }

}

.comparison-table-scroll {
  .table-column:first-child {
    border-right: 1px solid #ddd;
    box-shadow: 8px 0 7px -7px rgba(0,0,0,0.1);
  }
}
</style>